import { getUtmForRequest } from './utmTracker';
import { config } from '../constants/domainConfig';

// TallyMans expects these service names instead of the literal config.product value.
const SERVICE_NAME_OVERRIDES = {
    'fun-box': 'funbox',
    'moviotv': 'movio',
};

export default function buildCancelUrl(token) {
    const service = SERVICE_NAME_OVERRIDES[config.product] || config.product;
    const url = new URL(`${window.location.protocol}//${window.location.hostname}/cancel`);
    url.searchParams.append('service', service);
    url.searchParams.append('token', token || '');
    const utm = getUtmForRequest();
    Object.keys(utm).forEach((key) => url.searchParams.append(key, utm[key]));
    return url.href;
}
